import { render } from "./AppList.vue?vue&type=template&id=6ab1b040&scoped=true"
import script from "./AppList.vue?vue&type=script&lang=js"
export * from "./AppList.vue?vue&type=script&lang=js"

import "./AppList.vue?vue&type=style&index=0&id=6ab1b040&lang=css&scoped=true"

import exportComponent from "/home/ubuntu/sync.mydatacan/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ab1b040"]])

export default __exports__